module.exports = __webpack_public_path__ + "img/1583295548.e0f9e590.jpg";